<template>
  <div class="brochures-grid">
    <BrochureItem
      v-for="brochure in brochures.slice(0, 2)"
      :key="brochure.id"
      :brochure="brochure"
      class="brochure-item"
      :impression-source="BrochureImpressionSource.AlsoInteresting"
    />
  </div>
  <slot />
  <div class="brochures-grid">
    <BrochureItem
      v-for="brochure in brochures.slice(2, 4)"
      :key="brochure.id"
      :brochure="brochure"
      class="brochure-item"
      :impression-source="BrochureImpressionSource.AlsoInteresting"
    />
  </div>
</template>

<script setup lang="ts">
import {
  BrochureImpressionSource,
  type SimilarBrochuresForBrochureInput,
  useSimilarBrochuresForBrochureQuery,
} from "~/graphql/generated";

const props = defineProps<{
  title?: string;
  input: SimilarBrochuresForBrochureInput;
}>();

// Mark this as reactive, so the query will re-run when the value changes
const { data } = await useSimilarBrochuresForBrochureQuery({
  variables: {
    brochuresInput: props.input,
  },
});

const brochures = computed(() => data.value?.similarBrochuresForBrochure ?? []);
</script>

<style lang="scss" scoped>
.brochures-grid {
  display: grid;
  gap: 1.5rem;
  justify-content: center;
  grid-template-columns: 1fr 1fr;

  .brochure-item {
    :deep(.brochure-cover) {
      max-height: 150px;
    }
  }
}

.grid-title::first-letter {
  text-transform: capitalize;
}
</style>
